export function hsl(percent, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = 120; }
    var offset = (end - start) * percent;
    return "hsl(".concat(offset + start, ", 100%, 50%)");
}
export function mdToHtml(markdown) {
    return import('./internal/MarkdownImpl').then(function (_a) {
        var renderMd = _a.renderMd;
        return renderMd(markdown);
    });
}
export function isDifferent(form1, form2) {
    if (form1 === form2) {
        return false;
    }
    if (typeof form1 !== typeof form2) {
        return true;
    }
    if (Array.isArray(form1) && Array.isArray(form2)) {
        if (form1.length === form2.length) {
            for (var i = 0; i < form1.length; i++) {
                if (isDifferent(form1[i], form2[i])) {
                    return true;
                }
            }
            return false;
        }
    }
    else if (typeof form1 === 'object') {
        var keys = Object.keys(form1);
        if (!isDifferent(keys, Object.keys(form2))) {
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                // @ts-ignore
                if (isDifferent(form1[key], form2[key])) {
                    return true;
                }
            }
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=utils.js.map